// Tag pill, shared by the Tickets list and the ticket conversation. Clicking one
// (when onClick is given) filters by that tag.
//
// The tags table defaults every tag to #6366f1 and almost none were ever given a
// colour of their own (288 of 295 on 2026-10-23), so that default is treated as
// "no colour": those pills follow the brand theme's accent instead of staying
// Cyber-indigo on every theme. A tag with a real colour keeps it.
const DEFAULT_TAG_COLOR = "#6366f1";

export default function TagPill({ name, color, onClick, size = "sm" }) {
  const own = color && String(color).toLowerCase() !== DEFAULT_TAG_COLOR ? color : null;
  const look = own
    ? { color: own, background: `${own}1f`, border: `1px solid ${own}59` }   // 12% / 35% of the tag's own colour
    : { color: "color-mix(in srgb, var(--t-accent) 72%, var(--t-text-primary))",
        background: "var(--t-accent-softer)", border: "1px solid var(--t-accent-soft)" };
  return (
    <span
      onClick={onClick ? (e) => { e.stopPropagation(); onClick(name); } : undefined}
      title={onClick ? `Filter by "${name}"` : name}
      style={{
        display:"inline-flex", alignItems:"center", fontSize: size === "md" ? 12 : 10, fontWeight:700,
        letterSpacing:"0.02em", padding: size === "md" ? "3px 10px" : "2px 8px", borderRadius:99, whiteSpace:"nowrap",
        cursor: onClick ? "pointer" : "default", ...look,
      }}
    >
      {name}
    </span>
  );
}
